import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "form_pass",
  "use": "form_pass-usage",
  "viewBox": "0 0 20 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" preserveAspectRatio=\"xMidYMid\" viewBox=\"0 0 20 14\" id=\"form_pass\"><path d=\"M19.939 7.195S15.56 14 9.996 14 .053 7.195.053 7.195a.38.38 0 0 1 0-.39S4.432 0 9.996 0s9.943 6.805 9.943 6.805a.38.38 0 0 1 0 .39ZM9.996 2.8C7.91 2.8 6.218 4.68 6.218 7c0 2.32 1.692 4.2 3.778 4.2 2.086 0 3.778-1.88 3.778-4.2 0-2.32-1.692-4.2-3.778-4.2Zm0 5.6c-.695 0-1.259-.627-1.259-1.4 0-.773.564-1.4 1.259-1.4s1.259.627 1.259 1.4c0 .773-.564 1.4-1.259 1.4Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol